<template>
    <div>
        <CRow class="paySlipText">
            <CCol sm="8">
                <h1>Pay Slips</h1>
                <CCol class="paySlipText">
                    Select financial year
                </CCol>
                <select class="selectClass">
                    <option>2021-2022</option>
                    <option>2020-2021</option>
                    <option>2019-2020</option>
                    <option>2018-2019</option>
                    <option>2017-2018</option>
                </select>
                <CCol>
                    Oops, looks like we have not processed a payroll for you.
                </CCol>
                <CCol>
                    <CButton
                        size="sm"
                        class="buttonSize"
                        @click="backToDashboard"
                    >
                        RETURN TO DASHBOARD
                    </CButton>
                </CCol>
            </CCol>
        </CRow>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    methods: {
        backToDashboard() {
            this.$router.push('/dashboard');
        }
    }
};
</script>

<style scoped>
.paySlipText {
    margin-top: 20px;
}
.buttonSize {
    height: 50px;
    padding: 10px 40px;
    background-color: #272f51;
    color: white;
}
.selectClass {
    width: 60%;
    color: white;
    background-color: #272f51;
    padding: 10px;
    margin-bottom: 20px;
    margin-left: 10px;
}
.rightBox {
    background-color: white;
    width: 100%;
}
</style>
